import { useEffect, useState } from "react";
import { LedgerRecord } from "../../../services/interface";
import { sanitizeSearchInput } from "../../../../shared/utils/searchUtils";
import api from "../../../../features/auth/axiosConfig";

export function useLedgerSearch() {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState<LedgerRecord[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const delay = setTimeout(async () => {
      if (!searchTerm.trim()) {
        setResults([]);
        return;
      }
      try {
        setLoading(true);
      const res = await api.get(`/pos/ledger?pageNumber=1&pageSize=10&searchBy=${searchTerm}&includeSettled=true`);
        setResults(res.data.result);
      } catch (error) {
        console.error("Error fetching ledgers:", error);
      } finally {
        setLoading(false);
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  const handleSearchChange = (value: string) => {
    setSearchTerm(sanitizeSearchInput(value));
  };

  return { searchTerm, results, loading, setSearchTerm: handleSearchChange };
}
